/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 ListItem — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: hover/selected/focus gebruiken NS interactive tokens ipv palette.action,
// disabled opacity 0.5 (Tractie disabled), divider gebruikt NS border token, no transition.

export const MuiListItemLightOverrides = {
  root: {
    display: 'flex' as const,
    justifyContent: 'flex-start' as const,
    alignItems: 'center' as const,
    position: 'relative' as const,
    textDecoration: 'none' as const,
    width: '100%',
    boxSizing: 'border-box' as const,
    textAlign: 'left' as const,
    paddingTop: 8,
    paddingBottom: 8,
    transition: 'none',
    '&$focusVisible': {
      backgroundColor: 'var(--ns-color-bg-hover)',
    },
    '&$selected, &$selected:hover': {
      backgroundColor: 'var(--ns-color-bg-emphasis-secondary)',
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },

  container: {
    position: 'relative' as const,
  },

  focusVisible: {},

  dense: {
    paddingTop: 4,
    paddingBottom: 4,
  },

  alignItemsFlexStart: {
    alignItems: 'flex-start' as const,
  },

  disabled: {},

  divider: {
    borderBottom: '1px solid var(--ns-color-border-default)',
    backgroundClip: 'padding-box' as const,
  },

  gutters: {
    paddingLeft: 16,
    paddingRight: 16,
  },

  button: {
    transition: 'none',
    '&:hover': {
      textDecoration: 'none' as const,
      backgroundColor: 'var(--ns-color-bg-hover)',
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },

  secondaryAction: {
    paddingRight: 48,
  },

  selected: {},
} as const;

// Dark palette variant — tokens (--ns-color-bg-hover, --ns-color-bg-emphasis-secondary,
// --ns-color-border-default) zijn mode-aware via tokens.css. Geen mode-specifieke keys nodig.
export const MuiListItemDarkOverrides = {
  ...MuiListItemLightOverrides,
} as const;
